import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Link from 'components_new/atoms/Link'
import Text from 'components_new/atoms/Text'

import TextInput, {
  useTextInputState
} from 'components_new/molecules/TextInput'

import { useTranslation } from 'language/translator'
import { useDashboardGroupActions } from 'redux/actions/DashboardGroups'

interface InviteSectionProps {
  id: string
  onGoBack: () => void
}

const InviteSection = (props: InviteSectionProps) => {
  const { id, onGoBack } = props

  const { t } = useTranslation()
  const { tryInviteToDashboard } = useDashboardGroupActions()

  const email = useTextInputState()
  const message = useTextInputState()

  const hasErrors = Boolean(email.error || message.error)

  return (
    <>
      <Text variant="subtitle2" gutterBottom={true}>
        {t('users', 'invite_non_users_title')}
      </Text>
      <Text color="text.secondary" variant="body2" gutterBottom={true}>
        {t('users', 'already_a_user_question')}{' '}
        <Link color="inherit" onClick={onGoBack}>
          {t('users', 'go_back_and_add_user')}
        </Link>
      </Text>
      <Box sx={{ mt: 2 }}>
        <TextInput required variant="email" {...email} />
        <TextInput
          label={t('users', 'message')}
          autoComplete="off"
          variant="multiline"
          {...message}
        />
        <Button
          disabled={hasErrors}
          fullWidth
          variant="contained"
          size="large"
          onClick={() => {
            tryInviteToDashboard(id, {
              message: message.value,
              new_user_email: email.value
            })
            email.setValue('')
            message.setValue('')
          }}
        >
          {t('global', 'invite')}
        </Button>
      </Box>
    </>
  )
}

export default InviteSection
